/**
 * Promise utility which converts normal request to promise based
 * @export functionToPromiseWrapper
 * @param {function} functionToWrap - function to wrap
 * @param {...*} functionArgs - Any number of parameters required by functionToWrap
 * @returns {Promise} - The given function is wrapped as a promise
 */
export function functionToPromiseWrapper(functionToWrap, ...functionArgs) {
    return new Promise((resolve, reject) => {
        /**
         * Notice the 3 params to functionToWrap - ...args, and 2 callback functions
         *
         * The function to wrap's method signature is expected to have 2 call back functions
         * as its last two parameter. These callback functions are expected to handle a success
         * or failed invocation.
         */
        functionToWrap(
            ...functionArgs,
            function (response) {
                resolve(response);
            },
            function (error) {
                reject(error);
            }
        );
    });
}
